export { SingleproductHeaderComponent } from './header/singleproduct-header.component';
export { PricesComponent } from './prices/singleproduct-prices.component';
export { ModifiersComponent } from './modifiers/singleproduct-modifiers.component';
export { NoteComponent } from './note/singleproduct-note.component';
export { SuggestionsComponent } from './suggestions/singleproduct-suggestions.component';